import clsx from "clsx";
import React from "react";

export interface IFilterRowSkeletonProps {
  className?: string;
  fieldsCount?: number;
}

const FilterFieldSkeleton: React.FC<{ labelWidthClassName?: string }> = ({ labelWidthClassName = "w-24" }) => {
  return (
    <div className="h-[42px] w-full rounded-[10px] border border-[#E6E7EB] bg-white px-3 flex items-center">
      <div className={clsx("h-3 rounded bg-gray-200", labelWidthClassName)} />
      <div className="ml-auto h-3 w-3 rounded bg-gray-200" />
    </div>
  );
};

const getLabelWidthClass = (index: number): string => {
  if (index === 0) return "w-20";
  if (index === 3) return "w-32";
  return "w-24";
};

const FilterRowSkeleton: React.FC<IFilterRowSkeletonProps> = ({ className, fieldsCount = 6 }) => {
  return (
    <div className={clsx("w-full py-1", className)}>
      <div className="flex flex-wrap lg:flex-nowrap w-full justify-between items-center gap-3 animate-pulse">
        {Array.from({ length: fieldsCount }).map((_, index) => (
          <div key={index} className="w-full">
            <FilterFieldSkeleton labelWidthClassName={getLabelWidthClass(index)} />
          </div>
        ))}
        <div className="flex items-center">
          <div className="h-[36px] w-full rounded-[8px] bg-[#E6EBF2] xl:w-[128px]" />
        </div>
      </div>
    </div>
  );
};

export default FilterRowSkeleton;
